<template>
  <v-dialog v-model="isVisible" persistent :max-width="viewMode === 'clinic-fields' ? '1200px' : '600px'">
    <div v-if="isVisible" class="wrapper">
      <v-card v-if="viewMode === 'clinic-fields'">
        <v-card-title>
          <span class="headline">Provide practice details</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row class="fieldsRow">
              <v-col v-if="!isEditing" cols="6">
                <v-text-field v-model="fields.billPayAccountNumber" type="text" label="Bill pay account number *" />
                <div class="errorText">
                  {{
                    !fields.billPayAccountNumber.length && isFormDirty
                    ? "Please provide a value"
                    : ""
                  }}
                </div>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="fields.website" type="text" label="Website" />
                  {{ !fields.website.length && isFormDirty ? "Please provide a value" : "" }}
              </v-col>
              <v-col cols="6">

                <input ref="file" type="file" style="display: none" @change="onFileChange" />
                <div v-if="file" class="fileWrapper">
                  <div class="filePart">
                    <div class="iconWrapper">
                      <v-icon>mdi-file</v-icon>
                    </div>
                    <div class="nameWrapper">
                      {{ file && file.name ? file.name : "File" }}
                      <div class="fileSize">Size: {{ file ? formatMemory(file.size) : "" }}</div>
                    </div>
                  </div>
                  <div class="actionPart" @click="$refs.file.click()">
                    <div class="changeBtn">
                      <v-icon>mdi-refresh</v-icon>
                      Change
                    </div>
                    <div class="removeBtn" @click="onFileDelete">
                      <v-icon>mdi-delete</v-icon>
                    </div>
                  </div>
                </div>
                <div v-if="!file" class="uploadBtn" @click="$refs.file.click()">
                  <div class="iconWrapper">
                    <v-icon>mdi-attachment</v-icon>
                  </div>
                  <div class="labelWrapper">Click to select a logo</div>
                </div>


                  {{ !file && isFormDirty ? "Please provide a value" : "" }}

              </v-col>
              <v-col cols="6">
                <v-text-field v-model="fields.phoneNumber" type="text" label="Phone number" />

                  {{ !fields.phoneNumber.length && isFormDirty ? "Please provide a value" : "" }}

              </v-col>
              <v-col cols="6">
                <v-text-field v-model="fields.email" type="text" label="Email" />

                  {{ !fields.email.length && isFormDirty ? "Please provide a value" : "" }}

              </v-col>
              <v-col cols="6">
                <v-text-field v-model="fields.defaultPaymentMessage" type="text" label="Default Payment Message" />
              </v-col>
              <v-col cols="6">
                <v-combobox
                v-model="selectedMedicalGroup"
                :items="allMedicalGroups"
                 itemValue="MedicalGroupID"
                 itemText="Name"
                label="Select medical group"
                chips
              >
                <template v-slot:item="{ item }">
                  <v-chip dark label small>
                    {{ item.Name }}
                  </v-chip>
                </template>
              </v-combobox>
              </v-col>
              <v-col v-if="selectedMedicalGroup" cols="6">
                <v-combobox
                v-model="selectedFacilities"
                :items="allFacilities"
                 itemValue="id"
                 itemText="name"
                label="Select facilties"
                multiple
                chips
                clearable
                @click:clear="clearSelectedFacilities"
              >
              </v-combobox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="actionBar">
          <v-spacer />
          <v-btn color="secondary" text @click="close">
            Cancel
          </v-btn>

          <v-btn v-if="true" color="primary" text @click="_navigateToPrevStep">
            Previous
          </v-btn>
          <v-btn v-if="true" color="primary" text @click="_submit">
            Submit
          </v-btn>
        </v-card-actions>
        <v-snackbar v-model="snackbar">
          {{ notification }}

          <template v-slot:action="{ attrs }">
            <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-card>
      <v-card v-if="viewMode === 'medical-group-fields'">
        <v-card-title>
          <span class="headline">Provide Medical Group Details</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row class="fieldsRow">
              <v-col v-if="!isEditing" cols="6">
                <v-text-field v-model="medicalGroupFields.medicalGroupName" type="text" label="MedicalGroup Name *" />
                <div class="errorText">
                  {{
                    !medicalGroupFields.medicalGroupName.length && isMedicalGroupFormDirty
                    ? "Please provide a value"
                    : ""
                  }}
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="actionBar">
          <v-spacer />
          <v-btn color="secondary" text @click="close">
            Cancel
          </v-btn>

          <v-btn v-if="true" color="primary" text @click="_navigateToPrevStep">
            Previous
          </v-btn>
          <v-btn v-if="true" color="primary" text @click="_addMedicalGroup">
            Add Medical Group
          </v-btn>
        </v-card-actions>
        <v-snackbar v-model="snackbar">
          {{ notification }}

          <template v-slot:action="{ attrs }">
            <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-card>
      <v-card v-if="viewMode === 'clinic-list'">
        <v-card-title>
          <span class="headline">Select a clinic first</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row v-if="eligibleClinics && eligibleClinics.length > 0">
              <v-col cols="12" class="a-center">
                <h4>Available Clinics</h4>
              </v-col>
            </v-row>
            <v-row v-if="eligibleClinics && eligibleClinics.length === 0">
              <v-col cols="12" class="a-center">
                <h4>No Clinics Available</h4>
              </v-col>
            </v-row>
            <v-row v-if="eligibleClinics && eligibleClinics.length > 0">
              <v-col cols="12" class="phoneNumbersWrapper">
                <v-radio-group v-model="selectedClinicPracticeId" column>
                  <v-radio v-for="clinic in eligibleClinics" :key="clinic.POSPractice_ID"
                    :label="clinic.Company || '--'" :value="clinic.POSPractice_ID"
                    :disabled="!(clinic.POSPractice_ID && clinic.Company.length && clinic.is_active)" />
                </v-radio-group>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="actionBar">
          <v-spacer />
          <v-btn color="secondary" text @click="close">
            Cancel
          </v-btn>
          <v-btn v-if="selectedClinicPracticeId && selectedClinicPracticeId.length" color="primary" text
            @click="_navigateToNextStep">
            Next
          </v-btn>
        </v-card-actions>
        <v-snackbar v-model="snackbar">
          {{ notification }}

          <template v-slot:action="{ attrs }">
            <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-card>
      <v-card v-if="viewMode === 'loader'">
        <div class="progressWrapper">
          <v-progress-circular :size="70" :width="7" color="green" indeterminate class="spinner" />
        </div>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
  /* eslint-disable */
  import { VueMaskDirective } from "v-mask";
import Vue from "vue";
import { ApiCalls } from "../../../../api-calls";
import Api from "../../../shared-module/api";

  Vue.directive("mask", VueMaskDirective);

  export default {
    name: "AddTwilioNumber",
    props: {
      isVisible: {
        type: Boolean,
        default: false
      },
      isEditing: {
        type: Boolean,
        default: false
      },
      clinic: {
        type: Object,
        default: null
      },
    },
    data: () => ({
      snackbar: false,
      notification: '',
      eligibleClinics: [],
      viewMode: "clinic-list", //  ['loader', 'clinic-list', 'clinic-fields', 'medical-group-fields']
      selectedClinic: null,
      selectedClinicPracticeId: -1,
      allFacilities: [],
      selectedFacilities: [],
      allMedicalGroups: [],
      selectedMedicalGroup: null,
      fields: {
        billPayAccountNumber: "",
        timezone: "",
        website: "",
        logo: "",
        phoneNumber: "",
        email: "",
        defaultPaymentMessage: "",
      },
      medicalGroupFields: {
        medicalGroupName: "",
      },
      requiredFields: {
        add: [
          "billPayAccountNumber"
        ],
        edit: [
          //
        ]
      },
      file: null,
      isFormDirty: false,
      isMedicalGroupFormDirty: false,
      isFormValid: false
    }),

    watch: {
      isVisible(val) {
        if (val) {
          this._resetForm();
          if (this.isEditing) {
            this._prepareClinicEditMode();
          } else {
            this._prepareClinicAddMode();
          }
        }
      },
      // On medical group change fetch facilities
      selectedMedicalGroup(val) {
        if (val) {
        }
      }
    },

    created() {
      this._loadMedicalGroups();
    },

    methods: {

      clearSelectedFacilities() {
        this.selectedFacilities = [];
      },

      _resetForm() {
        this.isFormDirty = false;
        this.fields = {
          billPayAccountNumber: "",
          timezone: "",
          website: "",
          logo: "",
          phoneNumber: "",
          email: "",
          defaultPaymentMessage: "",
        };
        this.selectedClinicPracticeId = -1;
        this.selectedClinic = '';
        this.file = null;
        this.viewMode = "clinic-list";
        this.selectedFacilities = [];
      },

      async _loadEligibleClinics() {
        try {
          this.viewMode = "loader";
          const { data: eligibleClinics } = await Api.clinic.private.fetchActiveClinics();
          this.eligibleClinics = eligibleClinics && eligibleClinics.length ? eligibleClinics.filter(clinic => clinic.is_active) : this.allFacilities.push('N/A'); this.selectedFacilities.push('N/A');

        } catch (error) {
          console.log("error :>> ", error);
        }
        this.viewMode = "clinic-list";
      },

      close() {
        this.$emit("on-close");
      },

      _extractPracticeId(data) {
        if (data && data.length) {
          const parts = data.split("PracticeID: ");
          if (parts.length === 2) {
            // eslint-disable-next-line radix
            return parseInt(parts[1]);
          }
        }
        return null;
      },

      onFileDelete(e) {
        e.preventDefault();
        e.stopPropagation();
        this.file = null;
      },

      formatMemory(x) {
        const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        let l = 0;
        let n = parseInt(x, 10) || 0;

        while (n >= 1024 && ++l) {
          // eslint-disable-next-line operator-assignment
          n = n / 1024;
        }
        // include a decimal point and a tenths-place digit if presenting
        // less than ten of KB or greater units
        // eslint-disable-next-line prefer-template
        return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + units[l];
      },

      _checkIfFormIsValid() {
        // this.notification = "";
        this.isFormDirty = true;
        let isValid = true;
        // eslint-disable-next-line no-restricted-syntax
        const requiredFields = this.isEditing ? this.requiredFields.edit : this.requiredFields.add;
        // eslint-disable-next-line no-restricted-syntax
        for (const requiredField of requiredFields) {
          if (!this.fields[requiredField].length) {
            isValid = false;
            break;
          }
        }
        return isValid;
      },
      async _navigateToNextStep() {
        if (this.viewMode === 'clinic-list') {
          this.selectedClinic = this.eligibleClinics.find(clinic => clinic.POSPractice_ID === this.selectedClinicPracticeId);
          console.log('this.selectedClinic: ', this.selectedClinic);
          this.viewMode = "clinic-fields";
        }
        else {
          this.viewMode = "clinic-fields";
        }
      },

      async _addMedicalGroup() {
        if (!(this.medicalGroupFields.medicalGroupName && this.medicalGroupFields.medicalGroupName.length)) {
          this.notification = "Please enter a valid Medical Group Name";
          this.snackbar = true;
          return;
        }
        // Create medical group
        const payload = {
          Name: this.medicalGroupFields.medicalGroupName,
        }
        try {
          this.viewMode = "loader";
          const { data } = await Api.medicalGroup.private.createMedicalGroup(payload);
          console.log('Newly created medical group :>> ', data);
          this.selectedMedicalGroup = data[0];
          this.viewMode = "clinic-fields"
        } catch (error) {
          console.log('error :>> ', error);
          this.notification = "Unable to create medical group";
          this.snackbar = true;
        }
      },

      _navigateToPrevStep() {
        this.viewMode = "clinic-list";
      },

      async _preparePayload() {
        let payload = {};
        // Process file upload if needed
        let logoUrl = '';
        if (this.file) {
          logoUrl = await this._uploadLogo();
        }
        var facilities = this.selectedFacilities.map(facility => facility.id);
        let medicalGroupId = null;
        if (this.selectedMedicalGroup) {
          medicalGroupId = this.selectedMedicalGroup.MedicalGroupID;
        } else if (this.fields.selectedMedicalGroup && this.fields.selectedMedicalGroup.MedicalGroupID) {
          medicalGroupId = this.fields.selectedMedicalGroup.MedicalGroupID;
        }

        if (this.isEditing) {
          payload = {
            Company: this.selectedClinic && this.selectedClinic.Company ? this.selectedClinic.Company : (this.fields.company_name || ''),
            Practice_ID: this.clinic.Practice_ID,
            PBPAccountNumber: this.fields.billPayAccountNumber,
            TimeZone: this.fields.timezone,
            Website: this.fields.website,
            Logo: logoUrl,
            PhoneNumber: this.fields.phoneNumber,
            Email: this.fields.email,
            Default_Payment_Msg: this.fields.defaultPaymentMessage,
            MedicalGroupID: medicalGroupId,
            Facilities: facilities
          };
        } else {
          const selectedClinic = this.eligibleClinics.find(
            c => this.selectedClinicPracticeId === c.POSPractice_ID
          );
          payload = {
            Practice_ID: selectedClinic.POSPractice_ID,
            Company: selectedClinic.Company,
            PBPAccountNumber: this.fields.billPayAccountNumber,
            TimeZone: this.fields.timezone,
            Website: this.fields.website,
            Logo: logoUrl,
            PhoneNumber: this.fields.phoneNumber,
            Email: this.fields.email,
            Default_Payment_Msg: this.fields.defaultPaymentMessage,
            Facilities: facilities,
            MedicalGroupID: medicalGroupId,
          };
        }
        return payload;
      },

      async _uploadLogo() {
        try {
          const formData = new FormData();
          formData.append("file", this.file);
          const res = await ApiCalls.uploadMedia(formData);
          return res.data;
        } catch (error) {
          console.log("error :>> ", error);
          return "";
        }
      },

      async _submit() {
        const isFormValid = this._checkIfFormIsValid();
        if (isFormValid) {
          const payload = await this._preparePayload();
          try {
            this.viewMode = "loader";
            if (this.isEditing) {
              console.log('UpdateClinic Payload :>> ', payload);
              await Api.clinic.private.updateClinicData({
                clinicData: payload
              })
            } else {
              console.log('AddClinic Payload :>> ', payload);
              await ApiCalls.addClinic(payload);
            }
            console.log('Success Payload :>> ', payload);
            this.$emit("on-success");
            this.viewMode = "clinic-fields";
          } catch (error) {
            this.viewMode = "clinic-list";
            console.log('error :>> ', error.response);
            this.notification = error.response.data;
            this.snackbar = true;
          }
        }
      },

      onFileChange(e) {
        const allowedFileTypes = ["image/jpeg", "image/gif", "image/png"];
        const uploadedFile = e.target.files[0];
        // Check if file type is valid
        if (allowedFileTypes.indexOf(uploadedFile.type) > -1) {
          // Check if it exceeds the size limit
          const allowedFileSize = process.env.VUE_APP_MMS_ATTACHMENT_SIZE_LIMIT_IN_KB || 4 * 1024;
          if (uploadedFile.size / 1024 <= allowedFileSize) {
            // eslint-disable-next-line prefer-destructuring
            this.file = e.target.files[0];
          } else {
            this.notification = `File size too large, maximum allowed size is ${allowedFileSize /
              1024} MB`;
            this.snackbar = true;
          }
        } else {
          this.notification = "The selected file type is not allowed";
          this.snackbar = true;
        }
      },

      _prepareClinicAddMode() {
        this._loadEligibleClinics();
      },

      _prepareClinicEditMode() {
        this._loadClinicData();
      },

      async _loadClinicData() {
        this.viewMode = "loader";
        // Fetch clinic data
        console.log('this.clinic :>> ', this.clinic);
        await Api.clinic.private.fetchClinicData({ practiceId: this.clinic.Practice_ID }).then(x => {

          console.log(this.allMedicalGroups);
          this.selectedMedicalGroup = this.allMedicalGroups.find(medicalGroup => medicalGroup.MedicalGroupID === x.data.MedicalGroupID);

          this.fields = {
            billPayAccountNumber: x.data.PBPAccountNumber || '',
            website: x.data.Website || '',
            Logo: x.data.Logo || '',
            phoneNumber: x.data.PhoneNumber || '',
            email: x.data.Email || '',
            defaultPaymentMessage: x.data.Default_Payment_Msg || '',
            selectedMedicalGroup: this.selectedMedicalGroup,
            company_name: x.data.Company || '',
          };

          if (x.data.MedicalGroupID !== null) {
            if (x.data.facilities != null) {
              this.selectedFacilities = this._getClinicFacilityData(x.data.facilities, this.selectedMedicalGroup.medicalGroupID);
            }
            else {
              this.selectedFacilities.push('N/A');
            }

          }

          this.viewMode = "clinic-fields";

        });

      },
      _getClinicFacilityData(facilityIDs, medicalGroupID) {
        var facilityArray = []

        facilityIDs.forEach(facilityID => {

          Api.clinic.private.fetchClinicFacility({ facilityId: facilityID, medicalGroupId: medicalGroupID }).then(x => {
            if (x.data.length) {
              x.data.forEach(facId => {
                facilityArray.push(facId);
              });
            }
          });
        });

        return facilityArray;
      },
      async _loadMedicalGroups() {
        try {
          Api.medicalGroup.private.fetchAllMedicalGroups().then(x => {
            this.allMedicalGroups = x.data;

            if (x.data.Facilities != undefined) {
              this.selectedFacilities = x.data.Facilities
            }
            else {
              this.selectedFacilities.push('N/A');
              this.allFacilities.push('N/A');
            }

          });

        } catch (error) {
          console.log('error :>> ', error);
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
.a-center {
  text-align: center;
}

.phoneNumbersWrapper {
  max-height: 250px;
  overflow-y: scroll;
}

.actionBar {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 80px;
  padding-bottom: 25px;
  background-color: white;
}

.wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}

.progressWrapper {
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .spinner {
    margin-left: 0rem !important;
  }

  img {
    margin-bottom: 25px;
  }
}

.errorText {
  margin-top: -5px;
  color: red;
  height: 15px;
  // font-weight: 600;
}

.fieldsRow {
  padding-bottom: 4rem;
}
</style>
